import store from '../store';

// Returns all users in the same division as the user. Retrieves results for every division that the user is a
// member of.
const getAllDivisionUsersById = ({ division, usersById = store.getState().users.activeById }) => {
  const divisionUsersById = {};
  if (division !== undefined) {
    for (const divisionRelation of Object.values(division.users.byId)) {
      if (!divisionRelation.isDeleted) {
        const userId = divisionRelation.relationalId;
        const user = usersById[userId];
        if (user !== undefined) {
          divisionUsersById[userId] = user;
        }
      }
    }
  }
  return divisionUsersById;
};

export default getAllDivisionUsersById;